var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.012,
    height: 21.19,
    viewBox: "0 0 19.012 21.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "return",
    transform: "translate(-449.18 -431.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M449.18,503.9h7.125c.005.109.013.192.013.274q0,1.62,0,3.239c0,.463.224.61.653.428.521-.222,1.039-.451,1.564-.664a.449.449,0,0,1,.306,0c.5.2.994.4,1.473.637.495.245.76.028.746-.477-.028-1.048-.008-2.1-.008-3.144v-.287h7.123V512.1a2.926,2.926,0,0,0-1.914-.9,3.412,3.412,0,0,0-.007-.65,1.12,1.12,0,0,0-1.922-.511q-.68.772-1.333,1.566a1.125,1.125,0,0,0,.032,1.495q.609.723,1.225,1.44a1.139,1.139,0,0,0,2.008-.963.17.17,0,0,1,0-.046.521.521,0,0,1,.409.586c0,.8,0,1.592,0,2.388v1.875H449.725c-.435,0-.544-.109-.544-.543V504.116C449.18,504.038,449.18,503.96,449.18,503.9Z",
    transform: "translate(0 -67.518)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M457.094,431.842c-.113,1.278-.222,2.523-.333,3.782-.056,0-.117.013-.178.013h-6.451c-.039,0-.088.013-.117-.005-.113-.071-.27-.131-.314-.236a.506.506,0,0,1,.06-.385,1.875,1.875,0,0,1,.324-.34c.869-.869,1.74-1.736,2.6-2.609a.676.676,0,0,1,.519-.223c1.213.008,2.426,0,3.639,0Z",
    transform: "translate(-0.472 0)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M633.054,435.668l-.334-3.778c.073-.006.133-.016.193-.016,1.244,0,2.489-.006,3.734.007a.654.654,0,0,1,.416.167c.984.966,1.956,1.943,2.929,2.921.238.24.211.55-.058.662a.821.821,0,0,1-.3.038q-2.257,0-4.514,0h-2.065Z",
    transform: "translate(-171.97 -0.03)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M677.387,609.672c.259.306.483.567.7.832.194.234.2.449.011.6s-.4.1-.592-.122q-.584-.682-1.164-1.369a.415.415,0,0,1,0-.646q.586-.7,1.179-1.386a.387.387,0,0,1,.576-.1c.178.151.18.364,0,.584-.22.267-.446.529-.712.844.14,0,.235,0,.329,0,.518.025,1.04.02,1.553.084a1.983,1.983,0,0,1,1.607,1.881c.025,2.08.011,4.16.01,6.241a.372.372,0,0,1-.378.4c-.228,0-.376-.171-.376-.449q0-2.14,0-4.279c0-.576,0-1.15,0-1.726a1.35,1.35,0,0,0-1.384-1.393C678.317,609.668,677.884,609.672,677.387,609.672Z",
    transform: "translate(-212.702 -164.489)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M574.3,431.98h2.6c.112,1.252.222,2.5.335,3.772H573.96C574.073,434.5,574.184,433.246,574.3,431.98Z",
    transform: "translate(-116.914 -0.131)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M574.5,507.46v-3.04h3.2v3.032c-.431-.185-.852-.355-1.263-.547a.7.7,0,0,0-.651,0C575.372,507.1,574.949,507.267,574.5,507.46Z",
    transform: "translate(-117.42 -68.005)",
    fill: "#1c2b3e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBack);
export default __webpack_public_path__ + "static/media/money-back.60983b9ca4befdb7dce42d128007bf6f.svg";
export { ForwardRef as ReactComponent };